module.exports = __webpack_public_path__ + "static/media/echecke.d6c7609b.png";